import { render } from "./RegisteredTradesGroupingListing.vue?vue&type=template&id=ad16c9d0&ts=true"
import script from "./RegisteredTradesGroupingListing.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesGroupingListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__